module.exports = __webpack_public_path__ + "media/images/athletes/3417-35c82216023677b9b19a6ccd5ace3204.png";